/*
  ZOURETTI — winkelwagen: timer (Stap 5) en Complete the look (Stap 6).

  Timer: start bij het eerste product, loopt door bij paginawissel
  (sessionStorage, alleen dit tabblad), verdwijnt rustig bij 00:00.
  Leegt nooit de winkelwagen en blokkeert niets. Lege winkelwagen = timer
  wordt gewist, zodat hij bij het volgende eerste product opnieuw begint.

  Upsell (Complete the look, uitklapbaar + carrousel): het <details>-veld staat
  standaard dicht; open/dicht wordt onthouden zolang de pagina leeft, zodat het
  niet dichtklapt als het thema de winkelwagen opnieuw opbouwt. Bij openen
  worden de pijltjes opnieuw gemeten (dicht = breedte 0). Pijltjes schuiven één
  kaart op en verdwijnen als alles past; ADD toont kort een laadstatus en een
  foutmelding van Shopify staat 5 seconden onder de knop.

  Het thema bouwt de winkelwagen na elke wijziging opnieuw op; data-stamp
  verandert dan, en beide elementen zetten zichzelf opnieuw goed.
*/
(function () {
  const KEY = 'zr-cart-timer-end';
  const storage = {
    get() {
      try {
        return sessionStorage.getItem(KEY);
      } catch (error) {
        return null;
      }
    },
    set(value) {
      try {
        sessionStorage.setItem(KEY, value);
      } catch (error) {
        /* opslag niet beschikbaar: timer loopt alleen op deze pagina */
      }
    },
    clear() {
      try {
        sessionStorage.removeItem(KEY);
      } catch (error) {
        /* niets te wissen */
      }
    },
  };

  if (!customElements.get('zr-cart-timer')) {
    class ZrCartTimer extends HTMLElement {
      static get observedAttributes() {
        return ['data-stamp', 'data-count'];
      }

      connectedCallback() {
        this.schedule();
      }

      disconnectedCallback() {
        clearInterval(this.interval);
      }

      attributeChangedCallback() {
        this.schedule();
      }

      schedule() {
        if (this.queued) return;
        this.queued = true;
        queueMicrotask(() => {
          this.queued = false;
          this.start();
        });
      }

      start() {
        clearInterval(this.interval);
        const count = parseInt(this.dataset.count, 10) || 0;
        if (count === 0) {
          storage.clear();
          this.hidden = true;
          return;
        }

        let end = parseInt(storage.get(), 10);
        if (!end) {
          const minutes = parseFloat(this.dataset.minutes) || 10;
          end = Date.now() + minutes * 60000;
          storage.set(String(end));
        }
        this.end = end;

        if (this.tick()) {
          this.interval = setInterval(() => {
            if (!this.tick()) clearInterval(this.interval);
          }, 1000);
        }
      }

      tick() {
        const left = Math.round((this.end - Date.now()) / 1000);
        if (left <= 0) {
          this.finish();
          return false;
        }
        const time = this.querySelector('.zr-timer__time');
        if (time) {
          time.textContent =
            String(Math.floor(left / 60)).padStart(2, '0') + ':' + String(left % 60).padStart(2, '0');
        }
        this.hidden = false;
        return true;
      }

      finish() {
        if (this.hidden) return;
        this.classList.add('is-ending');
        setTimeout(() => {
          this.hidden = true;
          this.classList.remove('is-ending');
        }, 400);
      }
    }

    customElements.define('zr-cart-timer', ZrCartTimer);
  }

  if (!customElements.get('zr-upsell')) {
    let upsellError = null;
    /* Open/dicht van 'Complete the look', onthouden over het opnieuw opbouwen van de winkelwagen heen */
    let upsellOpen = false;

    class ZrUpsell extends HTMLElement {
      static get observedAttributes() {
        return ['data-stamp'];
      }

      connectedCallback() {
        if (!this.bound) {
          this.bound = true;

          /* Pijltjes: één kaart verder of terug */
          this.addEventListener('click', (event) => {
            const arrow = event.target instanceof Element && event.target.closest('.zr-upsell__arrow');
            if (!arrow || arrow.disabled) return;
            const list = this.querySelector('.zr-upsell__list');
            if (!list) return;
            const card = list.querySelector('.zr-upsell__item');
            const gap = parseFloat(getComputedStyle(list).columnGap) || 12;
            const step = card ? card.getBoundingClientRect().width + gap : list.clientWidth * 0.8;
            list.scrollBy({ left: step * Number(arrow.dataset.dir || 1), behavior: 'smooth' });
          });

          /* Uitklappen: stand onthouden en de pijltjes opnieuw meten zodra de lijst zichtbaar is */
          this.addEventListener(
            'toggle',
            (event) => {
              const details = event.target;
              if (!(details instanceof HTMLDetailsElement) || !details.classList.contains('zr-upsell__details')) return;
              upsellOpen = details.open;
              if (details.open) {
                requestAnimationFrame(() => this.updateArrows());
              }
            },
            true
          );

          this.addEventListener('cart:error', (event) => {
            const form = event.target instanceof Element && event.target.closest('product-form-component');
            if (!form) return;
            const button = form.querySelector('.zr-upsell__add');
            if (button) {
              button.classList.remove('is-loading');
              button.removeAttribute('aria-busy');
            }
            const data = event.detail && event.detail.data;
            const message = data && (typeof data.description === 'string' && data.description ? data.description : data.message);
            if (message) {
              upsellError = { id: form.dataset.productId, message: String(message), until: Date.now() + 5000 };
              this.showError();
            }
          });

          this.addEventListener(
            'submit',
            (event) => {
              const button = event.target instanceof Element && event.target.querySelector('.zr-upsell__add');
              if (!button) return;
              button.classList.add('is-loading');
              button.setAttribute('aria-busy', 'true');
              setTimeout(() => {
                button.classList.remove('is-loading');
                button.removeAttribute('aria-busy');
              }, 5000);
            },
            true
          );

          if ('ResizeObserver' in window) {
            this.resizer = new ResizeObserver(() => this.updateArrows());
          }
        }
        if (this.resizer) this.resizer.observe(this);
        this.restore();
      }

      disconnectedCallback() {
        if (this.resizer) this.resizer.disconnect();
      }

      attributeChangedCallback() {
        queueMicrotask(() => this.restore());
      }

      restore() {
        const details = this.querySelector('.zr-upsell__details');
        if (details && details.open !== upsellOpen) {
          details.open = upsellOpen;
        }
        const list = this.querySelector('.zr-upsell__list');
        if (list && list !== this.watchedList) {
          this.watchedList = list;
          list.addEventListener('scroll', () => this.updateArrows(), { passive: true });
        }
        this.updateArrows();
        this.showError();
      }

      /* Pijltjes alleen tonen als niet alle kaarten in beeld passen; uit aan het begin/einde */
      updateArrows() {
        const list = this.querySelector('.zr-upsell__list');
        const nav = this.querySelector('.zr-upsell__nav');
        if (!list || !nav) return;
        const max = list.scrollWidth - list.clientWidth;
        nav.hidden = max <= 2;
        const [prev, next] = nav.querySelectorAll('.zr-upsell__arrow');
        if (prev) prev.disabled = list.scrollLeft <= 2;
        if (next) next.disabled = list.scrollLeft >= max - 2;
      }

      showError() {
        clearTimeout(this.errorTimer);
        if (!upsellError) return;
        const left = upsellError.until - Date.now();
        const form = this.querySelector('product-form-component[data-product-id="' + upsellError.id + '"]');
        const box = form && form.querySelector('.zr-upsell__error');
        if (left <= 0 || !box) {
          if (left <= 0) upsellError = null;
          return;
        }
        box.textContent = upsellError.message;
        box.hidden = false;
        this.errorTimer = setTimeout(() => {
          box.hidden = true;
          box.textContent = '';
          upsellError = null;
        }, left);
      }
    }

    customElements.define('zr-upsell', ZrUpsell);
  }
})();